import Repository from "./masterRepository";
const GET = "getAdminPages";

export default {
  get(payload) {
    return Repository.post(transformRoute(GET), payload);
  },
};
const transformRoute = (route) => {
  return `/uibuilder/${route}`;
};
